import { Form, Input, Typography } from "antd";
import React from "react";
import { Flex, Spacer } from "src/components";
import styled from "styled-components";
import intl from "react-intl-universal";
import { eRequirement } from "src/utils/regCheck";
import GoolgeLoginButton, {
    StyledButton,
} from "src/components/AuthenticationPage/GoogleLoginButton";
import OrDivider from "src/components/AuthenticationPage/OrDivider";
import { PRIVACY_URL, TERMS_URL } from "src/utils/uri";
import { syncAutofillOnSubmit } from "src/components/AuthenticationPage/syncAutofill";

const { Text } = Typography;

interface RegisterOrLoginContentProps {
    fetchIfUserEmailExist: (email: string) => void;
    loading?: boolean;
}

const RegisterOrLoginContent: React.FC<RegisterOrLoginContentProps> = ({
    fetchIfUserEmailExist,
    loading = false,
}) => {
    const [form] = Form.useForm();

    return (
        <Flex justify="center" column onSubmitCapture={syncAutofillOnSubmit(form)}>
            <Spacer height={16} />
            <GoolgeLoginButton renderType="continue" />
            <OrDivider />
            <Form
                form={form}
                onFinish={(values) => fetchIfUserEmailExist(values.email)}
            >
                <StyledFormItem
                    name="email"
                    rules={[
                        {
                            required: true,
                            message: intl.get("authentication.warning.inputEmail"),
                        },
                        {
                            pattern: eRequirement,
                            message: intl.get("authentication.warning.inputValidEmail"),
                        },
                    ]}
                >
                    <StyledInput
                        size="large"
                        autoComplete="username"
                        placeholder={intl.get("authentication.shared.email")}
                    />
                </StyledFormItem>
                <StyledFormItem>
                    <StyledButton
                        htmlType="submit"
                        block
                        type="primary"
                        size="large"
                        loading={loading}
                        disabled={loading}
                    >
                        {intl.get("authentication.shared.continueWithEmail")}
                    </StyledButton>
                </StyledFormItem>
            </Form>
            <Spacer height={16} />
            <TermsAndConditionsText>
                {`${intl.get("authentication.shared.manorleadAccept")} `}
                <ClickableText href={TERMS_URL} target="_blank" rel="noopener noreferrer">
                    {intl.get("authentication.shared.termsOfUse")}
                </ClickableText>
                {" & "}
                <ClickableText href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
                    {intl.get("authentication.shared.privacyPolicy")}
                </ClickableText>
            </TermsAndConditionsText>
        </Flex>
    );
};

export default RegisterOrLoginContent;

const TermsAndConditionsText = styled(Text)`
    color: ${({ theme }) => theme.color.greySecondaryM};
    font-family: ${({ theme }) => theme.fontFamily.heading};
    font-size: ${({ theme }) => theme.fontSize.bodyXs}px;
    font-weight: 300;
    text-align: center;
`;

const StyledFormItem = styled(Form.Item)`
    && {
        margin: 0 auto 12px;
    }

    &&:last-child {
        margin-bottom: 0;
    }
`;

const ClickableText = styled.a`
    font-weight: 600;
    && {
        color: ${({ theme }) => theme.color.greySecondaryM};
    }
    font-family: ${({ theme }) => theme.fontFamily.homeBody};
    font-size: ${({ theme }) => theme.fontSize.bodyXs}px;
`;

const StyledInput = styled(Input)`
    color: ${({ theme }) => theme.color.blackPrimaryL};
    font-family: ${({ theme }) => theme.fontFamily.homeBody};
    font-size: ${({ theme }) => theme.fontSize.bodyL}px;
    border: ${({ theme }) => `1px solid ${theme.color.greySecondaryM}`};
    background-color: ${({ theme }) => theme.color.white};
    height: 44px;
    border-radius: 10px;
    padding: 8px 16px;
`;
